import { render, staticRenderFns } from "./MRNotes.vue?vue&type=template&id=43349654"
import script from "./MRNotes.vue?vue&type=script&lang=ts"
export * from "./MRNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports